// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const ShareIosFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M74.116 32.004h1.632V87.5H20.252V32.004h16.322v3.265H23.517v48.967h48.966V35.269H59.426v-3.265h14.69ZM36.248 25.15l-1.306.98-2.285-2.286.98-1.306L46.693 9.48 48 8.5l1.306.98 13.058 13.057.979 1.306-2.285 2.285-1.306-.98-10.12-10.446V61.384h-3.264V14.702L36.248 25.15Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default ShareIosFilled;
